export const USER_API_URL = "api/v2/users/me";
export const LISTING_API_URL = "api/v3/listings";
export const CATALOG_API_URL = "api/v2/catalogs";
export const TOOL_API_URL = "api/v3/tools";
export const CATEGORY_API_URL = "api/v3/categories";
export const PAGE_LAYOUT_API_URL = "api/v3/pagelayouts";
export const TEMPLATE_API_URL = "api/v3/templates";
export const STORE_API_URL = "api/v3/store";

export const ASSET_API_URL = "api/v3/assets";
export const GLOBAL_SETTINGS_API_URL = "api/v3/global-settings";
export const FILES_API_URL = "api/v3/files";
export const SIGNED_API_URL = "api/v3/signed-url";

export const SVG_MIME_TYPE = "image/svg+xml";
